
  
'use client'
import Link from 'next/link';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthCardWrapper from '../AuthCardWrapper';
import AuthLogin from '../auth-forms/AuthLogin';
import Logo from '@/app/ui-component/Logo';
import AuthFooter from '@/app/ui-component/cards/AuthFooter';
import { useIntl } from "react-intl";
import { useEffect, useState } from 'react';
import { getUniversityName } from '@/app/global-functions/getUniversityName';
import LocalizationSection from '@/app/layout/MainLayout/Header/LocalizationSection';
import { createDatabase } from '@/app/indexDB/CreateDatabase';
import { dispatch } from '@/app/store';
import { getUniversity } from '@/app/store/slices/diversParametersRedux';
// assets
// ================================|| AUTH3 - LOGIN ||================================ //

const Login = () => {
    const theme = useTheme();
    // const { isLoggedIn } = useAuth();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const intl = useIntl();

    const [abreviaturaUniversidade, setabreviaturaUniversidade] = useState("");
    const [universidae, setUniversidae] = useState("");

    useEffect(() => {
        fetchUniversityName();

      }, []);

    const fetchUniversityName = async () => {
        const university = await getUniversityName();
        setabreviaturaUniversidade(university.abreviatura);
        setUniversidae(university.nomUniversite);
      };

    return (
        <AuthWrapper1>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item sx={{ mb: 3 }}>
                                        <Link href="#">
                                            <Logo />
                                        </Link>
                                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                            <LocalizationSection />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction={matchDownSM ? 'column-reverse' : 'row'}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item>
                                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                    <Typography
                                                        color={theme.palette.secondary.main}
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h3' : 'h2'}
                                                        sx={{ textAlign: 'center' }} // Centering the text horizontally
                                                    >
                                                        {intl.formatMessage({ id: "login_message_administrateur" })}
                                                    </Typography>

                                                    <Typography
                                                        color={theme.palette.secondary.main}
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h4' : 'h3'}
                                                        sx={{ textAlign: 'center' }} // Centering the text horizontally
                                                    >
                                                        {intl.formatMessage({ id: "login_seja_bem_vindo" })}
                                                    </Typography>

                                                    <Typography
                                                        variant="caption"
                                                        fontSize="16px"
                                                        textAlign={matchDownSM ? 'center' : 'inherit'}
                                                        sx={{ textAlign: 'center' }} // Centering the text horizontally
                                                    >
                                                        {intl.formatMessage({ id: "login_info1" })}      
                                                        {abreviaturaUniversidade}
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AuthLogin />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                   
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                    <AuthFooter />
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
};

export default Login;
 